import React, { ChangeEventHandler } from 'react'
import styles from './checkbox.module.scss'

interface IProps {
  label?: string
  labelRight?: string
  name: string
  checked: boolean
  readOnly?: boolean
  handleChange?: any
  curried?: boolean
  modifiers?: string
}

const Checkbox = React.memo(function Checkbox({ curried = true, ...props }: IProps) {
  const handleChange = (event: any) => {
    event.stopPropagation()
    
    if (curried) {
      props.handleChange()(event.target.checked)
    } else {
      props.handleChange(event.target.checked)
    }
  }

  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      <label className={`tw-flex tw-items-center tw-cursor-pointer`}>
        {props.label && <span className={styles.inputLabel}>{props.label}</span>}
        <div className={`${styles.inputWrapper}`}>
          <input
            id={props.name}
            className={styles.input}
            checked={props.checked}
            type='checkbox'
            readOnly={props.readOnly}
            disabled={props.readOnly}
            onChange={(e) => handleChange(e)}
          />
          <span className={styles.checkmark} />
        </div>
        {props.labelRight && <span className={`${styles.inputLabelBig} tw-ml-5`}> {props.labelRight}</span>}
      </label>
    </div>
  )
})

export default Checkbox
